import { IInventoryPage } from '../../inventory-page.interface';


export const SETTINGS_PASSWORD_PAGE: IInventoryPage = {
	'route': '/settings/password',
	'title': 'Password',
	'uiReference': [
		'Enter your current password',
		'Enter your new password',
		'Confirm your new password',
		'Enter your OTP',
		'Reset password',
		'Forgot password',
		'Current password',
		'Please enter your current password!',
		'Forgot your password?',
		'New password',
		'Password should be 8 characters long with at least one uppercase and one lowercase letter!',
		'Verify password',
		'Confirm password is not matching!',
		'Save changes',
		'OTP',
		'Resend OTP',
		'Resend OTP in sec.',
		'OTP sent successfully, Please check your inbox.',
		'Please enter OTP!',
		'Back to password change'
	],
	'sources': [
		'apps/flying-projects/frontend/webapp/src/app/pages/shared/setting/setting-routing.module.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/shared/setting/settings-pages/general/password/password.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/shared/setting/settings-pages/general/password/password.component.html'
	]
};
